import { EthersAdapter } from '@reown/appkit-adapter-ethers';
import { polygon } from '@reown/appkit/networks';
import { createAppKit, Metadata } from '@reown/appkit/react';
import { FC, useEffect, useState } from 'react';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import AboutSkeleton from '../../components/skeleton/about/AboutSkeleton.tsx';
// import DescriptionSkeleton from '../../components/skeleton/description/DescriptionSkeleton.tsx';
// import EcosystemSkeleton from '../../components/skeleton/ecosystem/EcosystemSkeleton.tsx';
// import HeaderSkeleton from '../../components/skeleton/header/HeaderSkeleton.tsx';
// import NavigationSkeleton from '../../components/skeleton/navigation/NavigationSkeleton.tsx';
// import NftSkeleton from '../../components/skeleton/nft/NftSkeleton.tsx';
// import RoadmapSliderSkeleton from '../../components/skeleton/roadmap_slider/RoadmapSlider.tsx';
// import TimerSkeleton from '../../components/skeleton/timer/TimerSkeleton.tsx';
import { addDays } from 'date-fns';

// import { logout } from './hooks/useAuth';
import Navigation from '../lib/components/header/navigation';
import TimeModal from '../lib/shared/TimerModal';
import Header from '../lib/components/header';
import About from '../lib/components/about';
import Ecosystem from '../lib/components/ecosystem';
import Description from '../lib/components/desription';
import Nft from '../lib/components/nft';
import RoadmapSlider from '../lib/components/slider';
// const Roadmap = lazy(() => import('../../components/roadmap'));
import Footer from '../lib/components/footer';

// import './Landing.scss';
import '../lib/fonts/fonts.scss';

import { styled } from '@shared/styles';
import { UpdateFallbackModal } from '../lib/shared/UpdateFallbackModal';

let MainPage: FC<{ className?: string }> = ({ className }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add('landing');

    return () => {
      document.body.classList.remove('landing');
    };
  }, []);

  useEffect(() => {
    const now = new Date();

    const targetUTC = new Date(Date.UTC(2025, 11, 18, 12, 0, 0, 0));

    const msUntilTarget = targetUTC.getTime() - now.getTime();

    console.log('OPEN MS', msUntilTarget);

    console.log('SET OPEN');

    setOpen(true);
  }, []);

  return (
    <div id='main' className={className}>
      <div className='app_eclipse'></div>
      <UpdateFallbackModal enabled={false} />
      <TimeModal open={open} onClose={() => setOpen(false)} />
      <Navigation />
      <Header />
      <About />
      <Ecosystem />
      <Description />
      <Nft />
      <RoadmapSlider />
      {/* <Roadmap /> */}
      <Footer />
      {/*<ToastContainer theme='dark' />*/}
    </div>
  );
};

MainPage = styled(MainPage, {
  '*': {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    textDecoration: 'none',
    border: 'none',
    outline: 'none',
    listStyle: 'none',
    scrollBehavior: 'smooth',
    fontFamily: 'Fixel'
  },
  '&': {
    background: '#141518 !important',
    minHeight: '100vh',
    position: 'relative',
    maxWidth: '100vw',
    paddingTop: '89px',
    '@media (max-width: 1280px)': {
      paddingTop: '76px'
    }
  },
  '& ul': {
    listStyleType: 'none'
  },
  '& button': {
    border: 'none'
  },
  '.flex': {
    display: 'flex',
    alignItems: 'center'
  },
  '.grid': {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr'
  },

  '.app_roadmap': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },

  '.app_ecosystem': {
    paddingBottom: '80px'
  },

  '.MuiModal-root': {
    zIndex: '20 !important'
  },

  '.gradient_block': {
    top: 0,
    left: 0,
    position: 'absolute',
    width: '100vw',
    height: '80vh',
    background: 'transparent',
    borderRadius: '20px'
  },

  '.gradient_block::before': {
    content: '',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    background: 'radial-gradient(circle, #4d1aba9a 10%, transparent 60%)',
    filter: 'blur(280px)'
    // z-index: -1;
  },

  '.app_eclipse': {
    position: 'absolute',
    width: '100vw',
    left: '50%',
    transform: 'translateX(-50%) scale(1.2)',
    top: '237px',
    height: '2160px',
    background: 'radial-gradient(circle, #7d40ff9a 0%, rgba(0, 0, 0, 0) 100%)',
    opacity: '0.3',
    mixBlendMode: 'plus-lighter',
    filter: 'blur(100px)',
    pointerEvents: 'none'
  },

  '.dialog-nickname .MuiPaper-root': {
    maxSidth: '500px !important'
  },

  '.MuiCheckbox-root': {
    svg: {
      color: 'white'
    },
    '.MuiSvgIcon-root': {
      color: 'white !important'
    }
  },

  '.Toastify__toast-body': {
    paddingLeft: '0 !important'
  },

  '.Toastify__toast-container--top-center': {
    left: '0 !important',
    right: '0',
    transform: 'none !important',
    width: '100% !important'
  },
  '.list': {
    display: 'grid'
  },

  '.item': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',

    width: '100%',
    padding: '8px 0',
    height: '32px',

    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',

    color: 'var(--white)'
  },

  '.item > svg': {
    width: '15px',
    height: '15px',
    borderRadius: '100%'
  },

  '.item > span': {
    display: 'block',
    width: '2ch'
  },

  muiInputBaseInput: {
    padding: '12px 14px',
    outline: 'none',
    borderRadius: '6px',
    background: '#4f4867',
    color: '#afa5b8',
    fontSize: '18px'
  },

  muiFormControlLabelPlacementStart: {
    marginLeft: '0'
  },

  muiFormControlLabelLabel: {
    color: '#afa5b8',
    fontSize: '18px'
  },

  muiFocusedInput: {
    color: '#afa5b8'
  },

  muiFocused: {
    color: '#dfc7ff'
  },

  muiPaperRoot: {
    overflow: 'hidden',
    borderRadius: '16px',
    backgroundColor: 'transparent',

    '@media(max-width: 567px)': {
      borderRadius: '16px'
    }
  },

  muiFormControlLabelRoot: {
    marginRight: '0'
  },

  descMw: {
    maxWidth: '988px',

    '@media(max-width: 1440px)': {
      maxWidth: '751px'
    }
  },

  timerModal: {
    '@media(max-width: 567px)': {
      gap: '5px'
    },
    '& > div:first-child': {
      // add styles here
    }
  },

  '@media (max-width: 768px)': {
    '.MuiTabs-flexContainer': {
      flexDirection: 'column',
      padding: '10px 0',
      button: {
        width: '100% !important',
        minWidth: '100% !important'
      }
    }
  }
});

export { MainPage };
